import React, { useState, useEffect } from "react";

const SaleHistory = ({ userDetails }) => {
  const [saleHistory, setSaleHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchSaleHistory = async () => {
      try {
        const response = await fetch(
          `https://api.swalokgroup.com/api/get-sale-invoice`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch invoices");
        }
        const data = await response.json();

        data.sort((a, b) => new Date(b.sale_date) - new Date(a.sale_date));
        const filteredSales = data.filter(
          (sale) => sale.agent_name === userDetails.client_id
        );
        setSaleHistory(filteredSales); // Store the reports data in state
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchSaleHistory();
  }, [userDetails.client_id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create Date object
    return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
  };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>Sale History</span>
            <hr />
          </div>

          <div className="table-responsive text-center mt-4">
            <table className="w-100">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">Invoice No</th>
                  <th className="py-3 px-2">Date</th>
                  <th className="py-3 px-2">Plot Details</th>
                  <th className="py-3 px-2">Category</th>
                  <th className="py-3 px-2">Total</th>
                  <th className="py-3 px-2">Received</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="6" className="py-3 px-2">
                      Loading sale...
                    </td>
                  </tr>
                )}

                {saleHistory.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-3 px-2">
                      No Sale History found.
                    </td>
                  </tr>
                ) : (
                  saleHistory.map((sale, index) => (
                    <tr
                      className="text-muted para-text text-capitalize"
                      key={index}
                    >
                      <td className="py-3 px-2">{sale.id}</td>
                      {/* <td className="py-3 px-2">{sale.cust_name}</td>
                      <td className="py-3 px-2">{sale.agent_name}</td> */}
                      <td className="py-3 px-2">
                        {formatDate(sale.sale_date)}
                      </td>
                      <td className="py-3 px-2">{`Plot No: ${
                        JSON.parse(sale.plot_details)[1]
                      }, ${JSON.parse(sale.plot_details)[2]}`}</td>
                      <td className="py-3 px-2">{sale.booking_type}</td>
                      <td className="py-3 px-2">₹ {sale.total}</td>
                      <td className="py-3 px-2 text-success">
                        ₹ {sale.received}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* table ends */}
        </div>
      </section>
    </>
  );
};

export default SaleHistory;
